import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, FieldText, FlexBox, IconButton, Radio, } from '@dixa/lib-shared-habla';
import { Field } from 'redux-form';
import styles from './contactPointField.module.scss';
export const ContactPointField = ({ disabled, disabledPrimary, field, index, selectedIndex, totalRows, type, onSelect, onRemove, }) => {
    const isSelected = index === selectedIndex;
    /**
     * Calls remove callback and updates selected index if removed index precedes
     * it, to avoid changing selected value.
     */
    const onContactPointRemove = () => {
        if (index < selectedIndex)
            onSelect(selectedIndex - 1);
        onRemove(index);
    };
    return (_jsxs(FlexBox, Object.assign({ className: styles.root }, { children: [_jsx(Field, { component: FieldText, disabled: disabled || disabledPrimary ? isSelected : false, name: `${field}.value`, noLabel: true, type: "email", suffix: {
                    type: 'custom',
                    noWrap: true,
                    value: (_jsxs(FlexBox, Object.assign({ alignItems: "center" }, { children: [isSelected && (_jsx(Badge, Object.assign({ variant: "primary", size: "small" }, { children: "Primary" }))), _jsx(Radio, { checked: isSelected, id: `${field}${index}`, disabled: disabled || disabledPrimary, onChange: () => onSelect(index) })] }))),
                }, placeholder: `Enter contact’s ${type === 'email' ? 'email' : 'phone number'}` }), _jsx(FlexBox, Object.assign({ margin: "100 0 0 200" }, { children: _jsx(IconButton, { icon: "trash", variant: "tertiary", type: "button", disabled: disabled || totalRows === 1 || disabledPrimary ? isSelected : false, onClick: onContactPointRemove }) }))] })));
};
